export const FormatAddressFilterModule = angular
    .module('app.filters.formatAddressFilter', [])
    .filter('formatAddress', () => (address) => {
        if (!address) return;

        const { address1, address2, city, state, country, postalCode } = address;

        return encodeURIComponent(
            [address1, address2, city, state, country, postalCode]
                .filter(str => !!str)
                .join(' ')
        );
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/formatAddress.filter.js